<template>
	<v-col class="balance-mutation">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Detail Bonus Unilevel</div>
		</div>
		<div class="mt-5">
			<v-row justify="space-between" class="align-center mb-5">

				<v-col cols="12" sm="12" md="12" lg="12" class="py-0 py-sm-3">
					<div class="d-flex justify-end">
						<v-btn depressed color="grey lighten-1" class="mr-2 white--text rounded-xl text-capitalize" @click="reset">Reset</v-btn>
						<v-btn depressed color="primary" class="white--text rounded-xl text-capitalize" @click="showSearch">
							<div class="d-flex">
								<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
								<div class="d-none d-sm-block">Search</div>
							</div>
						</v-btn>
					</div>
				</v-col>
			</v-row>
			<div v-if="!loading">
				<v-row v-if="listDetailUnilevel.length > 0">
					<v-col cols="12" class="pt-0">
						<v-simple-table class="white-row table-vo table-vo-small table-history-transfer">
							<template v-slot:default>
								<thead class="">
									<tr>
										<th class="text-left" width="30%">Date</th>
										<th class="text-left" width="20%">Line</th>
										<th class="text-left" width="20%">Trigger</th>
										<th class="text-center" width="15%">Level</th>
										<th class="text-center" width="15%">Amount</th>
									</tr>
								</thead>
								<tbody class="grey--text text--darken-3">
									<tr v-for="(bonus) in listDetailUnilevel" :key="bonus.sales_group_id">
										<td class="text-left">{{ bonus.sales_group_date | toDate }}</td>
										<td class="text-left">
											<!-- <div>{{ bonus.netgrow_team_line_member_name }}</div> -->
											<div class="cl-primary">{{ bonus.sales_group_line_network_code }}</div>
										</td>
										<td class="text-left">
											<!-- <div>{{ bonus.netgrow_team_trigger_member_name }}</div> -->
											<div class="cl-primary">{{ bonus.sales_group_trigger_network_code }}</div>
										</td>
										<td class="text-center">{{ bonus.sales_group_level | toNumber }}</td>
										<td class="text-center">{{ bonus.sales_group_bonus | toCurrencyFormat }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="listDetailUnilevel.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
								<NoData></NoData>
								<div class="pt-3 text-center cl-primary">No unilevel bonus data available.</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
				<div v-if="listDetailUnilevel.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="detailUnilevelPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Showing {{ detailUnilevelPagination.total_display }} data from {{ detailUnilevelPagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" item-color="red darken-3" @input="changeLimit"></v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="mt-4" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
		<ModalCari ref="modalCari" @action="cari"></ModalCari>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalCari from './components/ModalCari';

export default {
	components: {
		ModalCari
	},
	data() {
		return {
			loading: false,
			startDate: false,
			dateStart: '',
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			params: [],
		}
	},
	computed: {
		...mapState('komisi', ['listDetailUnilevel', 'detailUnilevelPagination']),
	},
	methods: {
		...mapActions('komisi', ['getDetailUnilevel']),

		async getData() {
			this.loading = await true
			this.getDetailUnilevel(this.queryString({sort: 'sales_group_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		showSearch() {
			this.$refs.modalCari.modalShow()
		},
		reset() {
			this.page = 1
			this.limit = '10'
			this.params = []
			this.getData()
			this.$refs.modalCari.reset()
		},
		cari(data) {
			this.params = []
			this.page = 1

			if(data.date.value)
				this.params.push(data.date)
			if(data.line.value)
				this.params.push(data.line)
			if(data.trigger.value)
				this.params.push(data.trigger)
			if(data.level.value)
				this.params.push(data.level)
			this.getDetailUnilevel(this.queryString({sort: 'sales_group_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
				this.$refs.modalCari.modalHide()
			})
		},
		showModalKlaim() {
			this.$refs.modalKlaim.modalShow()
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `Detail Bonus Unilevel`)
		this.getData()
	}
};
</script>